import { kebabCase } from 'lodash-es';

import type { ShipmentListColumn } from './types';
import { ShipmentScope } from './types';

const TABLE_ID_PREFIX: string = 'shipments-list';

export const getTableId = (scope: ShipmentScope): string => `${TABLE_ID_PREFIX}-${kebabCase(scope)}`;

const scopeTableTitles: Record<ShipmentScope, string> = {
  [ShipmentScope.ALL]: 'All shipments',
  [ShipmentScope.COLLECTION]: 'Collection shipments',
  [ShipmentScope.DELIVERY]: 'Delivery shipments',
  [ShipmentScope.HIGH_PRIORITY]: 'High priority shipments',
  [ShipmentScope.IN_TRANSIT]: 'In transit shipments',
  [ShipmentScope.RECENTLY_DELIVERED]: 'Recently delivered shipments'
};

export const getTableTitle = (scope: ShipmentScope): string => scopeTableTitles[scope];

export const EMPTY_TEXT: string = 'There are no shipments to show.';

export const shipmentListColumns: ShipmentListColumn[] = [
  { fixed: 'left', key: 'reference', title: 'Reference' },
  { key: 'orders', sortable: false, title: 'Orders' },
  { key: 'modeOfTransport', title: 'Mode' },
  { key: 'status', title: 'Status' },
  { key: 'customer', title: 'Customer' },
  { key: 'cargo', sortable: false, title: 'Cargo' },
  { key: 'milestone', title: 'Milestone' },
  { key: 'cargoReadyDate', title: 'CRD' },
  { key: 'collectionAddress', title: 'Collection address' },
  { key: 'collectionDate', title: 'Collection date' },
  { key: 'deliveryAddress', title: 'Delivery address' },
  { key: 'deliveryDate', title: 'Delivery date' },
  { key: 'portOfLoading', title: 'Port of loading' },
  { key: 'departureDate', title: 'Departure date' },
  { key: 'portOfDischarge', title: 'Port of discharge' },
  { key: 'arrivalDate', title: 'Arrival date' },
  { key: 'incoterm', title: 'Incoterm' },
  { key: 'containerNumber', title: 'Container number' },
  { key: 'carrier', title: 'Carrier (SCAC)' },
  { key: 'masterBillOfLading', title: 'MBL' },
  { key: 'masterAirwayBill', title: 'MAWB' },
  { key: 'vehiclePlateNumber', title: 'Plate number' },
  { key: 'airShipmentType', title: 'Air shipment type' },
  { key: 'consolidationReference', title: 'Consolidation ref.' },
  { key: 'consignee', title: 'Consignee' },
  { key: 'shipper', title: 'Shipper' },
  { key: 'vessel', title: 'Vessel' }
];
